//  export let api = "http://localhost:5000";

  export let api = "https://api.casenect.com";

  // Oshnic Digital Signature Gateway Configuration
export const OSHNIC_API_KEY = "3u8yhhdf28dAF8f9fFNv7f98DNC9ddnw2710DJ8291dnjf77HJ";
export const OSHNIC_GATEWAY_URL = "http://localhost:5050/DigitalSignature/";
